import React, { useContext } from 'react';
import ThemeContext from 'shared/context/ThemeContext';
import { getText, TEXT_KEY } from 'shared/utils/localization';

const TiFormButton = props => {
  const { handleLinkBtn, handlePinAndAccount, error } = props;
  const { FormButton } = useContext(ThemeContext);

  return (
    <div
      style={FormButton.LinkBtn}
      onClick={() => {
        if (!error) handleLinkBtn(handlePinAndAccount);
      }}
    >
      {getText(TEXT_KEY.LINK)}
    </div>
  );
};

export default TiFormButton;

